import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ConfigurationField } from "../../types";

import { Label } from "@/components/ui/v2/label";
import { Switch } from "@/components/ui/v2/switch";

export function BooleanField({
  field,
  disabled,
  error,
}: {
  field: Extract<ConfigurationField, { type: "boolean" }>;
  disabled?: boolean;
  error?: string;
}) {
  const { setValue, watch } = useFormContext();
  const value = watch(field.key);
  const { t } = useTranslation();
  // Convert string "true"/"false" to boolean, default to false
  const boolValue = value === "true" || value === true;

  const handleChange = (checked: boolean) => {
    // Store as string "true"/"false" to match backend format
    setValue(field.key, checked ? "true" : "false");
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between space-x-2">
        <Label htmlFor={field.key} className="text-base">
          {t(field.label)}
          {field.required && <span className="text-destructive ml-1">*</span>}
        </Label>
        <Switch
          checked={boolValue}
          onCheckedChange={handleChange}
          disabled={disabled}
        />
        {error && <p className="text-sm text-destructive">{error}</p>}
      </div>
    </div>
  );
}
